
import userCache from '../../util/cache'

const user = {
  state: {
    SessionId: ''
  },

  mutations: {
    SET_User: (state, sessionId) => {
      userCache.addUser(sessionId)
      state.SessionId = sessionId
    },
    DEL_User: (state) => {
      userCache.delUser()
      state.SessionId = ''
    },
  },

  actions:{
    SetUser({commit}, sessionId){
      commit('SET_User', sessionId)
    },
    DelUser({commit}){
      commit('DEL_User')
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js